import { render, staticRenderFns } from "./EventTile.vue?vue&type=template&id=637f2c6c&scoped=true&"
import script from "./EventTile.vue?vue&type=script&lang=js&"
export * from "./EventTile.vue?vue&type=script&lang=js&"
import style0 from "./EventTile.vue?vue&type=style&index=0&id=637f2c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f2c6c",
  null
  
)

export default component.exports